import type { SVGProps } from "react";

export function IconWhitePackage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M27 7H7V57H57V7H37M27 7V19.5H37V7M27 7H37M50 34H38M50 34V46M50 34L40.9449 43.0551C37.7787 46.2213 33.4845 48 29.0069 48H28C20.268 48 14 41.732 14 34"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
